import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePublicAccess } from '../context/PublicAccessContext';
import { Eye } from 'lucide-react';

const GuestBanner = ({ message = "Sign up to interact with the community" }) => {
  const { user } = useAuth();
  const { showLoginPrompt } = usePublicAccess();

  // Don't show if user is logged in or prompts are disabled
  if (user || !showLoginPrompt) return null;

  return (
    <div className="bg-gradient-to-r from-primary/5 to-secondary/5 border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center shrink-0">
          <Eye className="w-4 h-4 text-muted-foreground" />
        </div>
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">Browsing as guest</span>
          {' — '}
          <Link to="/register" className="text-primary hover:underline">
            Sign up
          </Link>
          {' '}to post, comment, and interact with the community
        </p>
      </div>
    </div>
  );
};

export default GuestBanner;
